import { flatten } from "flat";

export class QueryInfo {
    params: {[key: string] : any}

    constructor(params: {[key: string] : any|undefined}) {
        this.params = params
    }
    
    toURLString(): string {
        let queryParamsString = ""
        for (const key in this.params) {
            const param: any = this.params[key];
            if (param || param === "") {
                if ((typeof param) === "object") {
                    let objectParams: any = {}
                    objectParams[key] = param
                    let flattenParams: any = flatten(objectParams) 
                    let bracketedParams = this.bracketed(flattenParams)
                    queryParamsString += (queryParamsString.startsWith("?") ? "&" : "?") + new QueryInfo(bracketedParams).toURLString().split("?").join("")
                }
                else {
                    queryParamsString += (queryParamsString.startsWith("?") ? "&" : "?") + ("data["+ key + "]=" + encodeURIComponent(param))
                }
            }
        }
        return queryParamsString
    }

    bracketed(nestedParams: {[key: string]: any}): {[key: string]: any} {
        let bracketedParms: {[key: string]: any} = {}
        for (const key in nestedParams) {
            let bracketedKey = key.split(".").join("][")     
            bracketedParms[bracketedKey] = nestedParams[key]   
        }        
        return bracketedParms
    }
}